module.exports = __webpack_public_path__ + "static/endpoint-purple-1fcc0863a8dfd9829a6e17425b97ad1e.png";